export default __webpack_public_path__ + "img/eZLacBJq.f896fd65.svg";